import React from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { NavLink, RouteComponentProps, withRouter } from "react-router-dom";
import { Collapse, Nav, NavItem } from "reactstrap";
import { IconName } from "@fortawesome/fontawesome-svg-core";

import { Icon } from "@app/Components/Icon";

type DropdownNavItemProps = RouteComponentProps & {
    title: string;
    icon?: IconName;
    items: Array<{
        title: string;
        to: string,
        icon?: IconName,
        onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
    }>;
};

class DropdownNavItem extends React.Component<DropdownNavItemProps> {
    @observable isOpen: boolean = false;

    constructor(props: DropdownNavItemProps) {
        super(props);
    }

    componentDidMount(): void {
        const { location, items } = this.props;
        const currentPath = location.pathname;
        if (items.some(i => i.to === currentPath)) {
            this.isOpen = true;
        }
    }

    render() {
        const { title, icon, items } = this.props;

        return (
            <NavItem>
                <div className="nav-link dropdown-toggle" onClick={this._toggle}>
                    {icon && <Icon name={icon} title={title} />}
                    <span className="nav-sidebar-title">{title}</span>
                </div>

                <Collapse isOpen={this.isOpen}>
                    <Nav vertical pills className="ml-3">
                        {items.map((item, i) => (
                            <NavItem key={i} >
                                <NavLink
                                    to={item.to}
                                    className="nav-link"
                                    activeClassName="active"
                                    onClick={item.onClick}
                                >
                                    {item.icon && <Icon name={item.icon} title={item.title} />}
                                    <span className="nav-sidebar-title">{item.title}</span>
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </Collapse>
            </NavItem>
        );
    }

    private _toggle = () => {
        const { location, items, history } = this.props;
        const currentPath = location.pathname;
        const isInItems = items.some(item => item.to === currentPath);

        if (!isInItems && items.length > 0 && !this.isOpen) {
            history.push(items[0].to);
        }

        this.isOpen = !this.isOpen;
    };
}

export default withRouter(observer(DropdownNavItem));